const hostName = window.location.hostname;

export const LOCAL_STORAGE_KEY = `${hostName}-downkount-app-`;
export const CHOSEN_LEAGUE = 'chosen-league';
export const CHOSEN_TEAM = 'chosen-team';
